import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para cualquier materia?',
  a: 'Sí. El sistema organiza decisiones; el contenido lo pones tú. Funciona desde Matemáticas hasta Literatura.'
}, {
  q: '¿Y si mi clase dura 50/60/90 min?',
  a: 'Ajustas tiempos de cada bloque, pero no eliminas la evidencia ni el cierre. El sistema es flexible en duración.'
}, {
  q: '¿Tengo que usar tecnología?',
  a: 'No. Las plantillas digitales ayudan, pero el sistema funciona perfectamente en papel o pizarrón.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full max-w-2xl mx-auto px-6 py-16" data-id="element-29">
      <h2 className="text-3xl font-serif font-bold text-navy mb-8 text-center" data-id="element-30">
        Preguntas rápidas
      </h2>

      <div className="space-y-4" data-id="element-31">
        {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden" data-id="element-32">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors" data-id="element-33">
              <span className="font-bold text-navy" data-id="element-34">{faq.q}</span>
              <motion.div animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.2
          }} data-id="element-35">
                <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-36" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-37">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-38">
                  <div className="p-4 pt-0 text-gray-600 border-t border-gray-100" data-id="element-39">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}